module.exports = __webpack_public_path__ + "img/no-tag1.d0becd05.png";